import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { useIsMobileDimension, useIsTabletDimension } from "../../../hooks/useGetDimensionGroup";
import style from "./styles.pcss";
var cn = classNames.bind(style);

/**
 * @description вставка СТРОГО только китовых компонентов, никаких оберток вокруг них,
 * экшн бар сам все разрулит по стилям
 */
export var ActionBar = /*#__PURE__*/memo(function (_ref) {
  var isWithText = _ref.isWithText,
    children = _ref.children,
    size = _ref.size,
    isLoading = _ref.isLoading,
    isNoPadding = _ref.isNoPadding,
    isNoFixHeight = _ref.isNoFixHeight;
  var isMobile = useIsMobileDimension();
  var isTablet = useIsTabletDimension();
  var buttonSize = 'm';
  if (size === 'm' && (isTablet || isMobile) || isMobile || size === 'l') {
    buttonSize = 'l';
  }
  var hasChildren = function hasChildren() {
    return React.Children.count(children) > 1;
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('action-bar', {
      'action-bar--empty': !children || isLoading,
      'action-bar--no-padding': isNoPadding,
      'action-bar--no-fix-height': isNoFixHeight
    }),
    "data-t-id": "components-ActionBar"
  }, !isLoading && React.Children.map(children, function (child, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !!child && (!isWithText || isWithText && i < React.Children.count(children) - 1) && /*#__PURE__*/React.createElement("li", {
      className: cn('action-bar__item', 'action-bar__item--upper', {
        'action-bar__item--upper-multiple': isWithText && hasChildren,
        'action-bar__item--upper-s': size === 's' && isWithText
      }),
      key: i
    }, /*#__PURE__*/React.cloneElement(child, {
      size: buttonSize,
      buttonSize: buttonSize,
      fullWidth: true,
      isFullWidth: true
    })), !!child && isWithText && i === React.Children.count(children) - 1 && /*#__PURE__*/React.createElement("li", {
      className: cn('action-bar__item'),
      key: i
    }, /*#__PURE__*/React.cloneElement(child)));
  }));
});